import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TierProductCardDumbDesktop from './TierProductCardDumbDesktop';
import TierProductCardDumbMobile from './TierProductCardDumbMobile';
const TierProductCardDumb = (props)=>{
    const isMobile = useContext(MobileContext);
    return isMobile ? /*#__PURE__*/ React.createElement(TierProductCardDumbMobile, props) : /*#__PURE__*/ React.createElement(TierProductCardDumbDesktop, props);
};
TierProductCardDumb.displayName = 'TierProductCardDumb';
export default TierProductCardDumb;
